const SubmitButton = (props) => {
  return (
    <>
      <button
        className=" bg-red-300 px-9 py-4 rounded-md text-black font-semibold disabled:bg-gray-300 disabled:text-gray-100 disabled:cursor-not-allowed mx-auto inline-block"
        type="submit"
        {...props}
      >
        {props.children}
      </button>
    </>
  );
};

export default SubmitButton;
